
  $(document).ready(function($) {
  "use strict";

      var desktopMegaMenuMinWidth = 990;

      function resetSubmenuState() {
        $('.menu-item-has-children > a').removeClass('selected');
        $('.menu-item-has-children > a').next('div.sub-menu-block').removeClass('is-hidden');
        $('.dt-nav li > div.sub-menu-block').removeAttr('style');
      }

      function syncInlineDesktopSubmenusForViewport() {
        var inlineSubmenus = $('.header__inline-menu .dt-nav li > div.sub-menu-block');
        if (!inlineSubmenus.length) return;

        if ($(window).width() < desktopMegaMenuMinWidth) {
          inlineSubmenus.each(function() {
            $(this).css({
              display: 'none',
              opacity: 0,
              visibility: 'hidden',
              pointerEvents: 'none'
            });
          });
          return;
        }

        inlineSubmenus.removeAttr('style');
      }

      function bindDesktopSubmenuHover() {
        $('.menu-item-has-children > a').off('.dtMegaMenuHover');

        if ($(window).width() < desktopMegaMenuMinWidth) {
          resetSubmenuState();
          return;
        }

        $('.menu-item-has-children > a')
          .on('mouseenter.dtMegaMenuHover', function(e) {
            var selected = $(this);
            selected.addClass('selected').next('div.sub-menu-block').removeClass('is-hidden');
          })
          .on('mouseleave.dtMegaMenuHover', function(e) {
            var selected = $(this);
            selected.removeClass('selected').next('div.sub-menu-block').removeClass('is-hidden');
          });
      }
        
    function megaMenu() {
        if ($(window).width() < desktopMegaMenuMinWidth) {
          return;
        }

      if($("#header .page-full-width").length) {
          var parentRow = $("#header .page-full-width > .row");
          var parentLeft = parseInt(parentRow.css("marginLeft").replace('px', ''));
        } else {
          var parentRow = $("#header .page-width .row");
          var parentLeft = parseInt(parentRow.offset().left);
        }
        var parentWidth = parentRow.width();   
  
        $("#header .page-width .dt-nav li:not(.close-nav)").each(function() {
          var thisItem = $(this);
          if(thisItem.hasClass('has-mega-menu')) {
            var thisItemLeft = thisItem.find('a').offset().left;
            var menuLeft = parseInt(thisItemLeft-parentLeft); 
            thisItem.find('.sub-menu-block').css('width', parentWidth);  
            thisItem.find('.sub-menu-block').css('left', -menuLeft);            
          }
        });

    $("sticky-header .dt-nav li:not(.close-nav)").each(function() {
      var thisItem = $(this);
      if(thisItem.hasClass('has-mega-menu')) {
        var thisItemLeft = thisItem.find('a').offset().left;
        var menuLeft = parseInt(thisItemLeft-parentLeft); 
        var menuLeft = menuLeft - 3; 
        thisItem.find('.sub-menu-block').css('width', parentWidth);
        thisItem.find('.sub-menu-block').css('left', -menuLeft);
      }      
    });
  }

  var megaMenuResizeTimer;
  $(window).on('resize.dtMegaMenu', function() {
    clearTimeout(megaMenuResizeTimer);
    megaMenuResizeTimer = setTimeout(function() {
          syncInlineDesktopSubmenusForViewport();
      bindDesktopSubmenuHover();
      if ($(window).width() >= desktopMegaMenuMinWidth) {
        megaMenu();
      } else {
        resetSubmenuState();
      }
    }, 120);
  });

      syncInlineDesktopSubmenusForViewport();
  bindDesktopSubmenuHover();
  megaMenu();
   
});


$(function() {
  if($(window).width() >=  1200) {
     $('.tabs-nav a').click(function() {
    let id = $(this).attr('href');           
    $('.tabs-nav li').removeClass('active');
    $(this).parent().addClass('active');             
    $(this).parent().parent().parent().parent().addClass('active');   
    $('.tabs-content li.dt-sc-menu-tabs').hide();      
    $(this).parent().parent().parent().parent().find(id).show();
   
    return false;
  });
}
  if($(window).width() <= 1199 ) {
  $('.mobileTabs .tabs  li').each(function(){
    $(this).click(function(){
      $(this).next('div').slideToggle(0);
    });
  })
}
});

$(document).ready(function(){
   $('#category-menu-button').click(function() { 
    $(this).toggleClass('open');
    $(".category-wrapper").toggleClass('open');
    $('.category-wrapper').slideToggle(0);
    });
});
